import request from "@/utils/request";

export function fetchList(param) {
  return request({
    url: 'api/console/innobackupex/list',
    method: 'post',
    data: param
  })
}

export function taskList(param) {
  return request({
    url: 'api/console/innobackupex/task/list',
    method: 'post',
    data: param
  })
}

export function backupCreat(param) {
  return request({
    url: 'api/console/innobackupex/create_or_update',
    method: 'post',
    data: param
  })
}

export function backupDelete(param) {
  return request({
    url: 'api/console/innobackupex/delete',
    method: 'post',
    data: param
  })
}

export function backupSwitch(param) {
  return request({
    url: 'api/console/innobackupex/enable_or_disable',
    method: 'post',
    data: param
  })
}






